
// SERVICES
require('modules/campaign-attachment/services/campaign-attachment');
require('modules/campaign-attachment/services/list');
require('modules/campaign-attachment/services/delete');


angular.module('unica_campaign_attachment', [

	// SERVICES
	'unica_campaign_attachment.campaign_attachment_services'

]);